import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import React from 'react';
import classnames from 'classnames';
import ImageDumbView from '../Image';
import LiteratureDumbView from '../Literature';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType, getBlurredThumbStyles } from '../../_helpers';
import s from './Premium.scss';
const PremiumDumbView = (_param)=>{
    var dumboProps = _extends({}, _object_destructuring_empty(_param));
    const { deviation, width, height, className } = dumboProps;
    const deviationType = getDeviationType(deviation);
    if (deviationType === DeviationTypes.IMAGE) {
        return /*#__PURE__*/ React.createElement(ImageDumbView, dumboProps);
    }
    if (deviationType === DeviationTypes.LITERATURE) {
        return /*#__PURE__*/ React.createElement(LiteratureDumbView, dumboProps);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className),
        style: {
            width: width || height,
            height: height || width
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['cdn-blurred-thumb'],
        style: getBlurredThumbStyles(deviation)
    }));
};
PremiumDumbView.displayName = 'PremiumDumbView';
export default PremiumDumbView;
